import { get } from './api'

/**
 * 解析链接令牌为推荐码（仅供注册页只读回显）。
 *
 * 失败一律静默返回 null —— 解析是锦上添花不是关卡：
 * 请求失败意味着「我们不知道」，不等于「这个码无效」；
 * 而且无论解析成功与否，提交都会携带令牌，由后端自行再解析一次（写入时权威）。
 */
export async function resolveReferralCode(token) {
  if (!token) return null
  try {
    const res = await get('/blade-portal/referral/resolve', { token })
    // 后端在 null 时会序列化成空串（BladeX Jackson 配置），按真值判断即可
    return res && res.code ? res.code : null
  } catch {
    return null
  }
}
